<template>
	<div>
		<a-form-model  ref="addForm"  :model="theObj"  :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
			<a-row>
				<a-col :span="12">
					<a-form-model-item label="小区" >
						<a-input  v-model="theNeighbor.label" :disabled="true"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="用户号">
						<a-input  v-model="theObj.customerNum" :disabled="true"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="12">
					<a-form-model-item label="用户名">
						<a-input  v-model="theObj.customerName"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="给水号">
						<a-input  v-model="theObj.apId" @blur="checkCustomerExist(false)"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="12">
					<a-form-model-item label="手机1">
						<a-input  v-model="theObj.customerMobile"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="手机2">
						<a-input  v-model="theObj.customerMobileNew"/>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="12">
					<a-form-model-item label="身份证">
						<a-input  v-model="theObj.nationalId"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="用水类型">
						<a-select  v-model="theObj.houseKindId">
							<a-select-option v-for="(item,index) in houseKindList"  :value="item.value" :key="item.value">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-form-model-item label="地址" :label-col="{ span: 2 }" :wrapper-col="{ span: 21 }" style="padding-left: 0.75rem;">
				<a-input  v-model="theObj.customerAddr"/>
			</a-form-model-item>
			<a-row>
				<a-col :span="12">
					<a-form-model-item label="余额阀值">
						<a-input-number  v-model="theObj.warnThre" :min="0" :precision="0" style="width:13rem;"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="提醒方式">
						<a-select v-model="theObj.warnStyle">
							<a-select-option v-for="(item,index) in warnStyleList" :value="item.value" :key="index">{{item.name}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="12">
					<a-form-model-item label="户数">
						<a-input-number  v-model="theObj.peoplecnt"  :min="0" :precision="0" style="width:13rem;"/>
					</a-form-model-item>
				</a-col>
				<a-col :span="12">
					<a-form-model-item label="IC卡">
						<a-input  v-model="theObj.idcard"/>
					</a-form-model-item>
				</a-col>
			</a-row>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="checkCustomerExist(true)">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default{
		props:[
			'theObj',
			'theNeighbor'
		],
		data(){
			return {
				submitFlag:false,
				oldAPID:this.Config.deepClone(this.theObj.apId)
			}
		},
		methods:{
			onClose:function(flag){
				this.$emit('cancelEdit');
				if(flag){
					this.$emit('refreshList');
				}
			},
			onSubmit:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_UPDATE_URL);
				this.Api.fetchPostWithForm(url,this.theObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('用户修改成功');
						this.onClose(true);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				});
			},
			checkCustomerExist:function(flag){
				if(flag){
					this.submitFlag = true;
				}
				if(this.theObj.apId!=null && this.theObj.apId.length>0 && this.theObj.apId!=this.oldAPID){
					let url = this.Api.getLastUrl(this.Api.CUSTOMER_CHECK_BY_APID_URL);
					let param = {APID:this.theObj.apId};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						let code = data.data.code;
						let result = data.data.result;
						let message = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							if(result == 1){
								this.$message.error('给水号已存在');
								if(flag && this.submitFlag == true){
									this.submitFlag = false;
								}
							}else{
								if(flag){
									this.onSubmit();
								}
							}
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						console.log(errorr);
					});
				}else{
					if(flag){
						this.onSubmit();
					}
				}
			},
		},
		computed:{
			houseKindList:function(){
				return this.Config.getHouseKindList();
			},
			warnStyleList:function(){
				return this.Config.getWarnStyleList();
			},
		}
	}
</script>

<style>
</style>
